import { Heading, Image, Link, Stack, Text } from '@chakra-ui/react';
import blowout from './img/blowout.svg';

export function Error() {
    return (
        <Stack spacing={8} mx={'auto'} w="full" py={12} px={6} alignItems={'center'}>
            <Image src={blowout} alt={'Error'} w={64} />
            <Heading fontSize={'4xl'}>Někdo nám to sfouknul...</Heading>
            <Text>
                Stalo se něco strašného a <strong>API systému je aktuálně nedostupné</strong>.
            </Text>
            <Text>Aplikace se bude pokoušet připojit zpátky...</Text>
            <Text>
                Pokud problém přetrvává, podívejte se do{' '}
                <Link href="https://podkotlem.cz/go/zaloha" target="_blank" rel="noreferrer" color="blue.500">
                    záložního dokumentu
                </Link>
                , nebo zavolejte Sonymu na{' '}
                <Link href="tel:+420730585427" color="blue.500">
                    730 585 427
                </Link>
                .
            </Text>
        </Stack>
    );
}
